<div class="content-box content-text">
    <div class="container">
        <div class="text-container">
            <p><strong>{{ messageText | translate }}</strong></p>
        </div>
        <div mat-dialog-actions>
            <button class="button-close" mat-button (click)="closeModal()">
                <mat-icon aria-hidden="false" aria-label="close">close</mat-icon>{{ 'stt.modalNoti.accept' | translate }}
            </button>
        </div>
    </div>
</div>